const host = "https://bgapi.izhanchi.com";
export { host }